import React from 'react'
import Button from '@material-ui/core/Button'
import styled from 'styled-components'
import ComponentConfig, {
  SaveButton,
  Footer,
} from 'organization/Event/DashboardConfig/ComponentConfigPanel'
import {useToggle} from 'lib/toggle'
import {useForm} from 'react-hook-form'
import {useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {BlogSectionProps} from 'Event/template/Townhall/Dashboard/Main/BlogSection'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import {Townhall} from 'Event/template/Townhall'
import {useAutoUpdate} from 'organization/Event/TemplateEditor'
import {
  FormFields,
  InputStylesSection,
  ButtonStylesSection,
} from 'Event/Dashboard/components/BlogPosts/PostFormStylesConfig'

export default function PostFormStylesConfig(props: {
  blogSection: BlogSectionProps
  sectionId: string
}) {
  const {flag: showingConfig, toggle: toggleConfig} = useToggle()
  const {blogSection, sectionId} = props
  const namePrefix = `dashboardSections.${sectionId}.postFormStyles.`

  const {
    control,
    handleSubmit,
    watch,
    formState: {isDirty},
  } = useForm()

  useAutoUpdate({
    values: watch(),
    when: showingConfig,
  })

  const update = useSaveTemplate()

  const save = (data: Townhall) => {
    update(data)

    toggleConfig()
  }

  const onClose = () => {
    toggleConfig()
  }

  return (
    <>
      <StyledEditPostFormStylesButton onClick={toggleConfig} />
      <ComponentConfig
        showing={showingConfig}
        onClose={onClose}
        title="Post Form Styles"
        hasChanges={isDirty}
        onSubmit={handleSubmit(save)}
      >
        <StylingPanel>
          <FormFields
            control={control}
            postFormStyles={blogSection.postFormStyles}
            namePrefix={namePrefix}
          />
          <InputStylesSection
            control={control}
            postFormStyles={blogSection.postFormStyles}
            namePrefix={namePrefix}
          />
          <ButtonStylesSection
            control={control}
            watch={watch}
            postFormStyles={blogSection.postFormStyles}
            namePrefix={namePrefix}
          />
        </StylingPanel>
        <Footer>
          <SaveButton type="submit" />
        </Footer>
      </ComponentConfig>
    </>
  )
}

function EditPostFormStylesButton(props: {
  onClick: () => void
  className?: string
}) {
  return (
    <Button
      className={props.className}
      fullWidth
      size="large"
      variant="contained"
      color="primary"
      aria-label="style post form"
      onClick={props.onClick}
    >
      Edit Post Form Styles
    </Button>
  )
}

const StyledEditPostFormStylesButton = styled(EditPostFormStylesButton)`
  margin-bottom: ${(props) => props.theme.spacing[3]}!important;
`
